import PropTypes from "prop-types"
import { DSIcon } from "ui/Icon/DSIcon"
import styles from "../../index.module.css"

const WaiverStatusTag = ({ status }) => (
  <span className={status === "Signed" ? styles.waiverSigned : styles.waiverUnsigned}>
    <DSIcon name="file" width={13} height={13} fill="currentColor" />
    {status}
  </span>
)

WaiverStatusTag.propTypes = { status: PropTypes.string.isRequired }

export default WaiverStatusTag
